// Removes every persisted auth/session key from localStorage.
//
// Kept dependency-free (no queryClient / no React imports) so it can be reused
// by both `signOut()` (utils/functions) and the global 401 handler
// (query-client) without creating an import cycle.
const SESSION_KEYS = [
  "token",
  "profilePhoto",
  "user",
  "userEmail",
  "userType",
  "phoneNumber",
  "showAccountSetupWarning",
  "orderId",
  "merhchantEmail",
  "buyerEmail",
];

export function clearStoredSession() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith("storeId:")) localStorage.removeItem(key);
  });
}
